import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'enl-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
